import * as yup from 'yup';

const noteSchema = yup.string().max(4000).label('Note');

export const annotationFormSchema = yup.object().shape({
  note: noteSchema,
  color: yup.string().required().label('Color'),
  shared: yup.bool().label('Shared'),
  visibleToUsers: yup.array(yup.string()).nullable(),
  visibleInClouds: yup.array(yup.string()).nullable(),
  annotatedText: yup.string(),
});

export const annotationFormNoteRequiredSchema = annotationFormSchema.shape({
  note: noteSchema.required(),
});
